export function DetailRow({ label, value }) {
  const display = value == null || value === '' ? '—' : value
  return (
    <div className="flex justify-between gap-4">
      <span className="text-muted-foreground">{label}</span>
      <span className="text-right font-medium">{display}</span>
    </div>
  )
}
